module.exports = __webpack_public_path__ + "static/img/19034C_3_4_C_20220227_fit.f97dd56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19034C_3_4_C_20220227_fit.png
// module id = M62m
// module chunks = 0